import { LoadingOutlined, UserOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  notification,
  Row,
  Spin,
} from "antd";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthService } from "../../../Services/AuthService";
import { useDispatch } from "react-redux";
import { setLoginUserData } from "../../Redex/UserSlice";
import ClientService from "../../Services/ClientService";
import { useUser } from "../../../Context/UserContext";
import { setIndianState } from "../../Redex/IndianStateSlice";
import layer from "../../Images/Layer_1.png";
import { MD5 } from "crypto-js";

const VendorLogIn = ({ onCancel, isModelOpen }: any) => {
  const [form] = Form.useForm();
  const { setCurrentUser } = useUser();
  const navigate = useNavigate();
  //   const { setIsLoggedIn } = props;
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 14, color: "white" }} spin />
  );
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);
  const [userEmail, setUserEmail] = React.useState("");
  const [isForgotpass, setIsforgotpass] = React.useState(false);
  const [ForgotPasswordForm] = Form.useForm();
  const [userData, setUserData] = React.useState<any>();

  const UserLogin = () => {
    form.validateFields().then(async (val: any) => {
      setLoading(true);
      var hashValue = MD5(val.password).toString();
      setLoading(true);
      await AuthService.login(val.username, hashValue)
        .then((user: any) => {
          if (user.token != null) {
            setUserData(user);
            // setIsLoggedIn(true);
            dispatch(setLoginUserData(user));

            sessionStorage.setItem("state", JSON.stringify(true));
            localStorage.setItem(
              "ci-config",
              JSON.stringify({
                darkMode: false,
                themeColor: "#3a5dd3",
                fontSize: 14,
                borderRadius: 6,
                componentSize: "middle",
                tablePageSize: 15,
                silderSize: true,
                zebraStriped: true,
              })
            );
          }
          setLoading(false);
        })
        .catch((ex) => {
          console.error("Login error", ex);
          setLoading(false);
        });
    });
  };

  React.useEffect(() => {
    if (userData) {
      const getState = async () => {
        await ClientService.getStateOption(true)
          .then((res: any) => {
            if (res.result) {
              const result = res.result;
              result.shift();
              setCurrentUser(userData, result);
              const x = {
                indState: result,
              };
              dispatch(setIndianState(x.indState));
              localStorage.setItem("IndianState", JSON.stringify(result));
              const vendorClientId = userData?.id;
              console.log("data", userData);
              userData?.userType === 2
                ? navigate(`/vendor/clients/${vendorClientId}/dashboard`)
                : notification.error({
                    message: "Error",
                    description: "Enter valid emailId and password",
                  });
            }
          })
          .catch((ex) => {
            console.error("Login error", ex);
            setLoading(false);
          });
      };
      getState();
    }
  }, [userData]);
  return (
    <>
      <div
        style={{
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          // paddingTop: "200px",
          display: "flex",
          background:
            "radial-gradient(80.32% 80.32% at 50% 50%, #058BC9 0%, #0E3878 100%)",
        }}
      >
        <div style={{ maxWidth: "390px", margin: "0 auto" }}>
          <Row gutter={15} justify={"center"} style={{ paddingBottom: "50px" }}>
            <Col>
              <img alt="capsi" src={layer} style={{ height: "40px" }} />
            </Col>
            <Col>
              <h1>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "white",
                  }}
                >
                  Capsi
                </span>
                <span
                  style={{
                    fontSize: "24px",
                    fontWeight: "400",
                    marginLeft: "9px",
                    color: "white",
                  }}
                >
                  Books
                </span>
              </h1>
            </Col>
          </Row>
          <Card size="small" type="inner" style={{ padding: "15px" }}>
            <p className="secondloginheading" style={{ color: "#4d4d4d" }}>
              Sign In
            </p>
            <p style={{ fontSize: "18px", fontWeight: "300" }}>
              Add your credentials to login as a Vender
            </p>

            <p className="thirdloginheading">
              {isForgotpass !== true ? (
                <></>
              ) : (
                <> Send mail for new password and sign in.</>
              )}
            </p>
            {isForgotpass !== true ? (
              <Form layout="horizontal" form={form} labelAlign="left">
                <Row>
                  <Col span={24} className="loginnames">
                    Username
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your username!",
                        },
                      ]}
                    >
                      <Input
                        suffix={
                          <UserOutlined style={{ color: "rgb(0,0,0,0.45)" }} />
                        }
                        onChange={(e: any) => {
                          setUserEmail(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} className="loginnames">
                    Password
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your password!",
                        },
                      ]}
                    >
                      <Input.Password type="password" />
                    </Form.Item>
                  </Col>
                </Row>
                {/* <Row style={{ margin: "4px 0px 8px 0px" }}>
                  <Col span={12}></Col>
                  <Col span={12} style={{ textAlign: "right" }}>
                    <Link onClick={() => setIsforgotpass(true)} to={""}>
                      Forgot password ?
                    </Link>
                  </Col>
                </Row> */}
                <Form.Item>
                  <Row justify="center">
                    <Col lg={24}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="check"
                        onClick={() => UserLogin()}
                        style={{
                          backgroundColor: "#058BC9",
                          color: "white",
                          width: "100%",
                        }}
                      >
                        {loading ? <Spin indicator={antIcon} /> : "Sign in"}
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            ) : (
              <Form
                requiredMark={false}
                form={ForgotPasswordForm}
                name="ForgotPassword"
                layout="vertical"
                initialValues={{ email: userEmail }}
              >
                <Row style={{ marginTop: "40px" }}>
                  <Col lg={24}>
                    <Form.Item
                      name="email"
                      label="Enter Your Email"
                      style={{ marginBottom: "40px" }}
                      rules={[
                        { required: true, message: "Required" },
                        { type: "email", message: "Invalid Email" },
                      ]}
                    >
                      <Input
                        style={{ height: "6vh", fontSize: "18px" }}
                        placeholder="example@gmail.com"
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      //   loading={loadings[1]}
                      //   onClick={postMail}
                      htmlType="submit"
                    >
                      Send Mail
                    </Button>
                    <Row justify={"end"}>
                      <Col>
                        <Link
                          to={""}
                          onClick={() => setIsforgotpass(!isForgotpass)}
                        >
                          Back to Login
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

export default VendorLogIn;
